import styled from 'styled-components';

export const CardContainer = styled.div<{ $backgroundColor?: string }>`
	box-sizing: border-box;
	display: flex;
	max-width: 360px;
	padding: 12px;
	align-items: center;
	gap: 12px;
	align-self: stretch;

	border-radius: ${({ theme }) => theme?.sizes?.borderRadius?.card};
  box-shadow: ${({ theme }) => theme?.shadows?.card};
  background: ${({ theme, $backgroundColor }) => $backgroundColor ?? theme?.colors?.theme?.contentBg};

	box-sizing: content-box;
`;

export const CardImage = styled.div`
  align-self: stretch;
  img {
		width: 96.478px;
		height: 96.478px;
		flex-shrink: 0;
    border-radius: ${({ theme }) => theme?.sizes?.borderRadius?.card};
    display: block;
    object-fit: cover;
  }
`;

export const CardContent = styled.div`
	display: flex;
	padding: 8px 0px;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	gap: 8px;
	flex: 1 0 0;
	box-sizing: border-box;

	span {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		align-self: stretch;

		overflow: hidden;
		text-overflow: ellipsis;
		font-size: 16px;
		font-style: normal;
		font-weight: 700;
		line-height: normal;
			box-sizing: border-box;
	}
`;
